import React, { useCallback, useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { RatingStar } from 'rating-star';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../layout/SubHeader/SubHeader';
import Button from '../../../components/bootstrap/Button';
import { dashboardMenu, demoPages } from '../../../menu';
import Avatar from '../../../components/Avatar';
import USERS from '../../../common/data/userDummyData';
import Card, {
	CardBody,
	CardFooter,
	CardFooterRight,
	CardFooterLeft,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Icon from '../../../components/icon/Icon';
import { priceFormat } from '../../../helpers/helpers';
import Input from '../../../components/bootstrap/forms/Input';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import showNotification from '../../../components/extras/showNotification';
import useDarkMode from '../../../hooks/useDarkMode';
import Select from '../../../components/bootstrap/forms/Select';
import { serEmp } from '../../../contexts/serempContext';
import { userAuth } from '../../../contexts/userContext';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import './ViewsServicePage.css';
import Carousel from 'react-material-ui-carousel';
import { Divider } from '@mui/material';
import Ratings from 'react-ratings-declarative';
import { useTranslation } from 'react-i18next';
import { getConfig } from '../../../config';
import apiServicewt from '../../../api/apiServicewt';
import { ensureGuestToken } from '../../../api/guestApiService';
import Popovers from '../../../components/bootstrap/Popovers';
import { useLanguageSwitch } from '../../../contexts/LanguageSwitchContext';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import {
	changeGoogleTranslateLanguage,
	getStoredLanguage,
} from '../../../helpers/languageSwitch';
import LANG, { getLangWithKey } from '../../../lang';
import { Ralert } from '../../common/vhelper/Normarodallalert';
import { getClientSlug } from '../../../helpers/clientSlug';

const validate = (values) => {
	const { t } = useTranslation();
	const errors = {};

	if (!values.name) {
		errors.name = t('*Required');
	} else if (values.name.length < 3) {
		errors.name = t('Must be 3 characters or more');
	} else if (values.name.length > 20) {
		errors.name = t('Must be 20 characters or less');
	}

	if (!values.price) {
		errors.price = t('*Required');
	} else if (values.price < 0) {
		errors.price = t('Price should not be 0');
	}

	if (!values.stock) {
		errors.stock = t('*Required');
	}

	if (!values.category) {
		errors.category = t('*Required');
	} else if (values.category.length < 3) {
		errors.category = t('Must be 3 characters or more');
	} else if (values.category.length > 20) {
		errors.category = t('Must be 20 characters or less');
	}

	return errors;
};

const ViewsServicePagewl = () => {
	const { t } = useTranslation();
	const { isLangSwitchEnabled } = useLanguageSwitch();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const [selectedLanguage, setSelectedLanguage] = useState(getStoredLanguage());

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	useEffect(() => {
		localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
		document.documentElement.setAttribute('theme', darkModeStatus ? 'dark' : 'light');
	}, [darkModeStatus]);

	const changeLanguage = async (lang) => {
		const nextLanguage = await changeGoogleTranslateLanguage(lang);
		setSelectedLanguage(nextLanguage);

		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(nextLanguage)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(nextLanguage)?.text}`}</span>
			</span>,
		);
	};

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const { id } = useParams();
	const navigate = useNavigate();

	const [data, setData] = useState({
		id: 7,
		image: 'data:image/jpeg;base64,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',
		name: '',
		category: '3D Shapes',
		series: [
			{
				data: [21, 34, 23, 12, 67],
			},
		],
		color: 'red',
		stock: 0,
		price: '',
		store: 'Company B',
		file: 'Figma',
		service_details: '',
	});

	const [empdata, setEmpData] = useState([]);
	const [variations, setVariations] = useState([]);
	const [slideImages, setSlideImages] = useState([]);
	const [activeempdata, setActiveEmpData] = useState([]);
	const [rating, setRating] = React.useState(30);

	const onRatingChange = (score) => {
		setRating(score);
	};

	const images = [
		// Add your image URLs here
		'https://img.freepik.com/premium-photo/hairdresser-using-hair-straightened-straighten-hair-hair-stylist-working-woman-s-hair-style-salonhair-care-beautiful-attractive-woman-beauty-salon_357889-5357.jpg',
		'https://images.pexels.com/photos/15202934/pexels-photo-15202934/free-photo-of-beautician-working-by-table.jpeg?auto=compress&cs=tinysrgb&w=600',
		'https://images.pexels.com/photos/11169557/pexels-photo-11169557.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
		'https://images.pexels.com/photos/13138585/pexels-photo-13138585.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
		'https://images.pexels.com/photos/4625617/pexels-photo-4625617.jpeg?auto=compress&cs=tinysrgb&w=600',
		'https://images.pexels.com/photos/7446912/pexels-photo-7446912.jpeg?auto=compress&cs=tinysrgb&w=600',
		'https://images.pexels.com/photos/9743914/pexels-photo-9743914.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
	];

	// useEffect(() => {
	//
	// 		const branchid = localStorage.getItem('selectedBranch');
	// 			const fetchata = async () => {
	// 				const item = {
	// 				action: 'active_emp_list',
	// 				services_id: id,
	// 				branch_id: branchid,
	// 				only_available_emp: 1,
	// 			};
	// 				const flechdata = await apiServicewt(item);
	// 				if (flechdata.type === 'Success' || flechdata.type === 'success') {
	// 					setActiveEmpData(flechdata.data);
	// 					//
	// 				}
	// 			};
	// 			fetchata();
	// 		}, []);

	useEffect(() => {
		const fetchata = async () => {
			const branchid = localStorage.getItem('selectedBranch');
			const item = { action: 'service_data_wl', service_id: id, branch_id: branchid };
			const weblink = getConfig().REACT_APP_WEB_LINK;
			const slug = getClientSlug();
			const payload = slug ? { ...item, slug: slug } : item;

			const response = await fetch(weblink, {
				method: 'post',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
				body: JSON.stringify(payload),
			});
			const flechdata = await response.json();

			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				const details = flechdata.service_details;
				setData(details);
				setActiveEmpData(flechdata.active_emp_list);

				if (Array.isArray(JSON.parse(details.filepath))) {
					const imageArray = JSON.parse(details.filepath);
					const slideimg = imageArray.map((d, i) => ({
						url: d,
						caption: 'Slide ' + (i + 1),
					}));
					setSlideImages(slideimg);
				}

				setEmpData(Object.values(flechdata.employees_list));

				const defaultVariation = {
					variation_id: 0,
					value: details.duration,
					price: details.price,
					type: 'duration',
					type_name: 'Duration',
					type_id: 1,
					is_default: true,
				};

				if (Array.isArray(details.variations) && details.variations.length > 0) {
					setVariations([defaultVariation, ...details.variations]);
				} else {
					setVariations([]);
				}
			}
		};
		fetchata();
	}, [Number(id)]);

	const TABS = {
		SUMMARY: 'Details',
		COMMENTS: 'Specialists',
		EDIT: 'Reserve',
		NEXT: 'Next',
		EMP: 'Emp',
	};

	const [activeTab, setActiveTab] = useState(TABS.SUMMARY);
	const [activeEmployee, setActiveEmployee] = useState(null);
	const [selectedEmployee, setSelectedEmployee] = useState({});
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const [isMobile, setIsMobile] = useState(false);

	const [loadalert, setLoadalert] = useState(false);
	const [msgloadalert, setMsgLoadalert] = useState('');
	const [msgtypeloadalert, setMsgtypeLoadalert] = useState('');

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		window.addEventListener('resize', handleResize);
		handleResize();

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const characterLimit = windowWidth < 870 ? 20 : windowWidth < 1203 ? 24 : 40;
	const promnamecharLimit = windowWidth < 870 ? 18 : windowWidth < 1203 ? 24 : 40;

	const [editItem] = useState(data);
	const formik = useFormik({
		initialValues: {
			name: '',
			price: '',
			stock: '',
			category: '',
		},
		validate,
		// eslint-disable-next-line no-unused-vars
		onSubmit: (values) => {
			showNotification(
				<span className='d-flex align-items-center'>
					<Icon icon='Info' size='lg' className='me-1' />
					<span>{t('Updated Successfully')}</span>
				</span>,
				t('The appointment has been updated Successfully'),
			);
		},
	});
	useEffect(() => {
		if (editItem) {
			formik.setValues({
				name: editItem.name,
				price: editItem.price,
				stock: editItem.stock,
				category: editItem.category,
			});
		}
		return () => {
			formik.setValues({
				name: '',
				price: '',
				stock: '',
				category: '',
			});
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [editItem]);

	const { setServiceidcont } = useContext(serEmp);

	const OnClickToCalender = useCallback(async () => {
		if (activeempdata && activeempdata.length === 0) {
			startmodel();
			setMsgLoadalert(t('No active Specialists data available.'));
			setMsgtypeLoadalert('warning');
			return;
		}

		try {
			await ensureGuestToken();
			setServiceidcont(() => id);
			navigate(`../${dashboardMenu.Celender.path}`);
		} catch (error) {
			startmodel();
			setMsgLoadalert(t('Unable to start guest checkout. Please try again.'));
			setMsgtypeLoadalert('error');
		}
	}, [activeempdata, id, navigate, setServiceidcont, t]);

	const spanStyle = {
		padding: '20px',
		background: '#efefef',
		color: '#000000',
	};

	const divStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundSize: 'cover',
		height: '400px',
	};
	// const slideImages = [
	// 	{
	// 		url: 'https://i.pinimg.com/736x/47/d8/72/47d8727762dea0e9f8d40058ace78204.jpg',
	// 		caption: 'Slide 1',
	// 	},
	// 	{
	// 		url: 'https://files.myglamm.com/site-images/original/V-cut-layer-for-medium-hair.png',
	// 		caption: 'Slide 2',
	// 	},
	// 	{
	// 		url: 'https://qph.cf2.quoracdn.net/main-qimg-bf053c7a2b051a81355838406fdbe5fb-pjlq',
	// 		caption: 'Slide 3',
	// 	},
	// ];
	const properties = {
		transitionDuration: 300,
	};

	const closemodel = () => {
		setLoadalert(false);
	};
	const startmodel = () => {
		setLoadalert(true);
	};

	const Newrating = (key, r) => {
		// const r=Number(Math.round(ele.rating_score)*20);

		return (
			// <RatingStar
			// 	colors={{ rear: '#3d4349' }}
			// 	noBorder={true}
			// 	maxScore={100}
			// 	id={`rating-${key}`}
			// 	rating={r}
			// 	// onRatingChange={
			// 	// 	onRatingChange
			// 	// }
			// />

			<Ratings
				id={`rating-${key}`}
				rating={r}
				widgetDimensions='22px'
				widgetRatedColors='rgb(255, 207, 82)'>
				<Ratings.Widget widgetSpacing='2px' />
				<Ratings.Widget widgetSpacing='2px' />
				<Ratings.Widget widgetSpacing='2px' />
				<Ratings.Widget widgetSpacing='2px' />
				<Ratings.Widget widgetSpacing='2px' />
			</Ratings>
		);
	};
	return (
		<>
			<Ralert
				msgloadalert={msgloadalert}
				msgtypeloadalert={msgtypeloadalert}
				loadalert={loadalert}
				closemodel={closemodel}
			/>
			<PageWrapper>
				<Page container='fluid'>
					<SubHeader>
						<SubHeaderLeft style={{ width: isMobile ? '100%' : 'auto' }}>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: isMobile ? 'space-between' : 'flex-start',
									gap: 8,
									width: '100%',
								}}>
								<Button
									color='info'
									isLink
									icon='ArrowBack'
									onClick={() => navigate('/')}>
									{t('Back to Services')}
								</Button>
								{isMobile && (
									<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
										<Popovers trigger='hover' desc='Dark / Light mode'>
											<Button
												{...styledBtn}
												icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
												onClick={() => setDarkModeStatus((prev) => !prev)}
												aria-label='Toggle theme'
												data-tour='dark-mode'
											/>
										</Popovers>
										{isLangSwitchEnabled && (
											<Dropdown>
												<DropdownToggle hasIcon={false}>
													<Button
														{...styledBtn}
														icon={getLangWithKey(selectedLanguage)?.icon}
														aria-label='Change language'
														data-tour='lang-selector'
													/>
												</DropdownToggle>
												<DropdownMenu
													isAlignmentEnd
													data-tour='lang-selector-menu'>
													{Object.keys(LANG).map((key) => (
														<DropdownItem key={LANG[key].lng}>
															<Button
																icon={LANG[key].icon}
																onClick={() =>
																	changeLanguage(LANG[key].lng)
																}>
																{LANG[key].text}
															</Button>
														</DropdownItem>
													))}
												</DropdownMenu>
											</Dropdown>
										)}
									</div>
								)}
							</div>
						</SubHeaderLeft>
						<SubHeaderRight>
							{!isMobile && (
								<div className='row g-3'>
									<div className='col-auto'>
										<Popovers trigger='hover' desc='Dark / Light mode'>
											<Button
												{...styledBtn}
												icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
												onClick={() => setDarkModeStatus((prev) => !prev)}
												aria-label='Toggle fullscreen'
												data-tour='dark-mode'
											/>
										</Popovers>
									</div>
									{isLangSwitchEnabled && (
										<div className='col-auto'>
											<Dropdown>
												<DropdownToggle hasIcon={false}>
													<Button
														{...styledBtn}
														icon={getLangWithKey(selectedLanguage)?.icon}
														aria-label='Change language'
														data-tour='lang-selector'
													/>
												</DropdownToggle>
												<DropdownMenu
													isAlignmentEnd
													data-tour='lang-selector-menu'>
													{Object.keys(LANG).map((key) => (
														<DropdownItem key={LANG[key].lng}>
															<Button
																icon={LANG[key].icon}
																onClick={() =>
																	changeLanguage(LANG[key].lng)
																}>
																{LANG[key].text}
															</Button>
														</DropdownItem>
													))}
												</DropdownMenu>
											</Dropdown>
										</div>
									)}
								</div>
							)}

							<div style={{ display: 'flex', width: isMobile ? '100%' : 'auto' }}>
								<Button
									// color={darkModeStatus ? 'light' : 'dark'}
									style={{
										borderRadius: '10px',
										margin: '10px',
										flex: isMobile ? 1 : undefined,
									}}
									color='success'
									isLight
									icon='Login'
									onClick={() => {
										// setEditItem(null);
										// setEditPanel(true);
										navigate('/login?type=login');
									}}>
									{t('Log In')}
								</Button>
								<Button
									style={{
										borderRadius: '10px',
										margin: '10px',
										flex: isMobile ? 1 : undefined,
									}}
									color='info'
									isLight
									icon='PersonAddAlt'
									onClick={() => {
										navigate('/login?type=reg');
									}}>
									{t('Sign Up')}
								</Button>
							</div>
						</SubHeaderRight>
					</SubHeader>
					<div className='display-4 fw-bold py-3 mx-2'>
						{data.name.length > promnamecharLimit
							? `${data.name.substring(0, promnamecharLimit)}...`
							: data.name}
					</div>
					<div className='row h-100'>
						<div className='col-lg-4'>
							<Card stretch>
								<CardBody>
									<div className='row g-3'>
										<div className='col-12 '>
											<div className='card-img-wrapper'>
												{data.service_lable &&
													data.service_lable.trim() !== '' && (
														<div className='corner-ribbon'>
															{data.service_lable}
														</div>
													)}
												<div
													className='slide-container'
													style={{
														overflow: 'hidden',
														borderRadius: '10px',
														height: isMobile ? '300px' : '400px',
													}}>
													<Carousel
														indicators={false}
														animation={'slide'}
														duration={400}>
														{slideImages.map((item, index) => (
															<div
																key={index}
																style={{
																	height: '400px',
																	...divStyle,
																}}>
																<img
																	src={item.url}
																	style={{
																		objectFit: 'cover',
																		width: '100%',
																		height: '100%',
																	}}
																/>
															</div>
														))}
													</Carousel>
												</div>
											</div>
										</div>
										<br />
										<div className='col-12'>
											<Button
												icon='Summarize'
												color='info'
												className='w-100 p-3'
												onClick={() => setActiveTab(TABS.SUMMARY)}>
												{t(TABS.SUMMARY)}
											</Button>
										</div>
										<div className='col-12'>
											<Button
												icon='Person'
												color='primary'
												className='w-100 p-3'
												onClick={() => setActiveTab(TABS.COMMENTS)}>
												{t(TABS.COMMENTS)}
											</Button>
										</div>
										<div className='col-12'>
											<Button
												icon='Edit'
												color='success'
												className='w-100 p-3'
												//disabled={activeempdata.length === 0}
												onClick={() => {
													// navigate('/login', {
													// 	state: {
													// 		type: 'login',
													// 		service_id: id,
													// 	},
													// });
													startmodel();
													setMsgLoadalert(
														t('Please log in to reserve this service.'),
													);
													setMsgtypeLoadalert('warning');
												}}>
												{t(TABS.EDIT)}
											</Button>
										</div>
									</div>
								</CardBody>
							</Card>
						</div>
						<div className='col-lg-8'>
							<Card
								stretch
								className='overflow-hidden'
								tag='form'
								noValidate
								onSubmit={formik.handleSubmit}>
								{activeTab === TABS.SUMMARY && (
									<>
										{/* <CardHeader>
										<CardLabel icon='Summarize' iconColor='info'>
											<CardTitle>Details</CardTitle>
											<CardSubTitle>Service Information</CardSubTitle>
										</CardLabel>
									</CardHeader> */}
										<CardBody>
											<div className='row'>
												<div className='col-lg-6'>
													<Card
														stretch
														shadow='sm'
														className={`bg-l${
															darkModeStatus ? 'o25' : '25'
														}-success rounded-2`}>
														<CardHeader className='bg-transparent pb-3 pb-md-0'>
															<CardLabel>
																<CardTitle>
																	{t('Service Name')}
																</CardTitle>
															</CardLabel>
														</CardHeader>
														<CardBody className='pt-0 pt-md-3'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='done_all'
																		size='4x'
																		color='success'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='fw-bold fs-3 mb-0'>
																		{data.name.length >
																		characterLimit
																			? `${data.name.substring(
																					0,
																					characterLimit,
																			  )}...`
																			: data.name}
																	</div>
																</div>
															</div>
														</CardBody>
													</Card>
												</div>
												<div className='col-lg-6'>
													<Card
														stretch
														shadow='sm'
														className={`bg-l${
															darkModeStatus ? 'o25' : '25'
														}-success rounded-2`}>
														<CardHeader className='bg-transparent pb-3 pb-md-0'>
															<CardLabel>
																<CardTitle>
																	{t('Category')}
																</CardTitle>
															</CardLabel>
														</CardHeader>
														<CardBody className='pt-0 pt-md-3'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='widgets'
																		size='4x'
																		color='success'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='fw-bold fs-3 mb-0'>
																		{data.catname}
																	</div>
																</div>
															</div>
														</CardBody>
													</Card>
												</div>
												<div className='col-lg-6'>
													<Card
														stretch
														shadow='sm'
														className={`bg-l${
															darkModeStatus ? 'o25' : '25'
														}-primary rounded-2`}>
														<CardHeader className='bg-transparent pb-3 pb-md-0'>
															<CardLabel>
																<CardTitle>{t('Price')}</CardTitle>
															</CardLabel>
														</CardHeader>
														<CardBody className='pt-0 pt-md-3'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='payments'
																		size='4x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='fw-bold fs-3 mb-0'>
																		{data.currency + ' ' + ``}
																		{priceFormat(data.price)}
																	</div>
																	{/* <div className='text-muted'>
																	<b>Quantity: </b> {data.stock}
																</div> */}
																</div>
															</div>
														</CardBody>
													</Card>
												</div>
												<div className='col-lg-6'>
													<Card
														stretch
														shadow='sm'
														className={`bg-l${
															darkModeStatus ? 'o25' : '25'
														}-info rounded-2`}>
														<CardHeader className='bg-transparent pb-3 pb-md-0'>
															<CardLabel>
																<CardTitle>
																	{t('Duration')}
																</CardTitle>
															</CardLabel>
														</CardHeader>
														<CardBody className='pt-0 pt-md-3'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='access_time'
																		size='4x'
																		color='info'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='fw-bold fs-3 mb-0'>
																		{data.duration}{' '}
																		{data.duration && (
																			<b>
																				{/* &nbsp;&nbsp; : &nbsp;min{' '} */}
																				&nbsp;min{' '}
																			</b>
																		)}
																	</div>
																</div>
															</div>
														</CardBody>
													</Card>
												</div>
												<div className='col-12 shadow-3d-container'>
													<h4>{t('Description')}</h4>
													{data.description !== '' ? (
														<div style={{ fontSize: '15px' }}>
															{data.description}
														</div>
													) : (
														<p
															style={{
																fontSize: '15px',
																color: '#999',
															}}>
															{t('No description available')}
														</p>
													)}
												</div>
												{variations && variations.length > 0 && (
													<div
														className='col-12 shadow-3d-container mt-3'
														style={{
															borderRadius: '16px',
															border: '3px solid #575b7230',
															padding: '12px',
														}}>
														<h4>{t('Variations')}</h4>
														<div
															style={{
																padding: '8px',
																display: 'flex',
																flexWrap: 'wrap',
																gap: '12px',
															}}>
															{variations.map((item) => (
																<div
																	key={item.variation_id}
																	style={{
																		background: darkModeStatus
																			? '#2d2f41'
																			: '#dee2e6',
																		borderRadius: '20px',
																		padding: '8px 16px',
																		fontSize: '14px',
																		display: 'flex',
																		gap: '8px',
																		alignItems: 'center',
																		border: item.is_default
																			? '2px solid #00c6a7'
																			: 'none',
																	}}>
																	<span>
																		⏱ {item.value} {t('min')}
																	</span>
																	<span>
																		💵 {data.currency}{' '}
																		{item.price}
																	</span>
																	{item.is_default && (
																		<span
																			style={{
																				color: '#00c6a7',
																				fontWeight: 'bold',
																			}}>
																			{t('Default')}
																		</span>
																	)}
																</div>
															))}
														</div>
													</div>
												)}
											</div>
										</CardBody>
									</>
								)}
								{activeTab === TABS.COMMENTS && (
									<>
										<CardHeader>
											<CardLabel icon='Person' iconColor='info'>
												<CardTitle>{t('Specialists')}</CardTitle>
											</CardLabel>
										</CardHeader>
										<CardBody isScrollable>
											<div className='row g-4'>
												{empdata && empdata.length > 0 ? (
													empdata.map((ele, index) => (
														<>
															<div
																className='col-12 d-flex align-items-center employee-card'
																style={{
																	cursor: 'pointer',
																	fontSize: '20px',
																}}
																onClick={() => {
																	setActiveTab(TABS.EMP);
																	setActiveEmployee(ele.id);
																	setSelectedEmployee(ele);
																	setRating(ele.rating_score);
																	console.log(
																		'rating',
																		Math.round(
																			ele.rating_score,
																		),
																	);
																}}>
																<div className='flex-shrink-0'>
																	{ele.prof_img !== undefined ? (
																		ele.prof_img !== null ? (
																			ele.prof_img !== '' ? (
																				<Avatar
																					className='avatar'
																					//srcSet={User1Webp}
																					src={
																						ele.prof_img
																					}
																				/>
																			) : (
																				<Avatar
																					className='avatar'
																					srcSet={
																						USERS.GRACE
																							.src
																					}
																				/>
																			)
																		) : (
																			// <Avatar srcSet={User1Webp} />
																			<Avatar
																				className='avatar'
																				srcSet={
																					USERS.GRACE.src
																				}
																			/>
																		)
																	) : (
																		<Avatar
																			className='avatar'
																			srcSet={USERS.GRACE.src}
																		/>
																	)}
																</div>
																<div className='flex-grow-1 ms-3 d-flex justify-content-between align-items-center'>
																	<figure className='mb-0'>
																		{/* <blockquote className='blockquote'> */}
																		<div
																			style={{
																				marginBottom:
																					'-15px',
																			}}>
																			<p
																				className='employee-name'
																				/*style={{
																		cursor: 'pointer',
																		fontSize: '20px',
																	}}
																	onClick={() => {
																		setActiveTab(TABS.EMP);
																		setActiveEmployee(ele.id);
																	}}*/
																			>
																				{ele.name}
																			</p>
																		</div>

																		{/* <Link style={{ textDecoration:'none',color:'white' }} to={`/appointment/employee/${ele.id}`} >{ele.name}</Link> */}
																		{/* </blockquote> */}
																		{/* <blockquote className='blockquote'> */}
																		<div className='col-12'>
																			{/* <h4>Review</h4> */}
																			<div
																				/*style={{
																			display: 'flex',
																			alignItems: 'center',
																			marginLeft: '3px',
																		}}*/
																				className='rating-container'>
																				<p
																					/*style={{
																				fontSize: '22px',
																				// marginTop: '20px',
																				fontWeight: '3px',
																			}}*/
																					className='rating-score'>
																					{parseFloat(
																						ele.rating_score,
																					).toFixed(1)}
																				</p>
																				<div
																					// style={{
																					// 	marginBottom: '20px',
																					// }}
																					className='rating-stars'>
																					{/* {console.log(
																			'rrrrating1',
																			Number(
																				Math.round(
																					ele.rating_score,
																				) * 20,
																			),
																		)} */}
																					{Newrating(
																						index,
																						ele.rating_score,
																					)}
																				</div>
																				{/* <p
																			style={{
																				fontSize: '12px',
																				// marginTop: '22px',
																			}}>
																			20 Reviews
																		</p> */}
																			</div>
																		</div>
																		{/* </blockquote> */}
																		<figcaption className='mb-0'>
																			{ele.emp_note}
																			{/* {USERS.GRACE.name} in{' '}
																<cite title='Company'>
																	Schedulerdesk
																</cite> */}
																		</figcaption>
																	</figure>
																</div>
															</div>
															<Divider
																className='mt-4'
																sx={{
																	color: ' #4b535b',
																}}></Divider>
														</>
													))
												) : (
													<div
														style={{
															padding: '120px',
															textAlign: 'center',
															fontSize: '18px',
															color: '#6c757d',
														}}>
														No Specialists Assigned
													</div>
												)}
											</div>
										</CardBody>
									</>
								)}
								{activeTab === TABS.EDIT && (
									<div>
										<CardBody>
											<Card>
												<CardHeader>
													<CardLabel
														icon='Description'
														iconColor='success'>
														<CardTitle>{t('Book Now')}</CardTitle>
													</CardLabel>
												</CardHeader>
												<CardBody>
													<div className='row g-4'>
														<div className='col-6'>
															{/* <FormGroup id='date' label='Date'>
															<Input
																onChange={(e) =>
																	setBdate(e.target.value)
																}
																type='date'
															/>
														</FormGroup> */}
															<FormGroup id='date' label={t('Date')}>
																<Input
																	onChange={(e) =>
																		setBdate(e.target.value)
																	}
																	type='date'
																	min={
																		new Date()
																			.toISOString()
																			.split('T')[0]
																	} // add min attribute to limit to future dates
																/>
															</FormGroup>
														</div>

														<div className='col-12'>
															<Card
																isCompact
																borderSize={2}
																shadow='none'
																className='mb-0'>
																<CardHeader>
																	<CardLabel>
																		<CardTitle>
																			{t('Employee')}
																		</CardTitle>
																	</CardLabel>
																</CardHeader>
																<CardBody>
																	<FormGroup
																		id='status'
																		label={t('Select')}
																		isFloating>
																		<Select
																			placeholder={`${t(
																				'Choose',
																			)}...`}
																			list={tableOption}
																			onChange={(e) => {
																				e.preventDefault();
																				setEmpid((tre) => {
																					const temp = {
																						...tre,
																						empid: e
																							.target
																							.value,
																					};
																					return temp;
																				});
																				console.log(
																					e.target.value,
																				);
																			}}
																		/>
																	</FormGroup>
																</CardBody>
															</Card>
														</div>
													</div>
												</CardBody>
											</Card>
										</CardBody>
										<CardFooter>
											<CardFooterRight>
												<Button
													icon=''
													color='success'
													className='w-100 p-3'
													disabled={activeempdata.length === 0}
													onClick={OnClickToCalender}>
													{TABS.NEXT}
												</Button>
											</CardFooterRight>
										</CardFooter>
									</div>
								)}
								{activeTab === TABS.EMP && (
									<>
										{/* <CardHeader>
												<CardLabel icon='Person' iconColor='info'>
													<CardTitle>Employees</CardTitle>
												</CardLabel>
											</CardHeader> */}
										<CardBody>
											<div className='col-lg-12'>
												<Card style={{ marginTop: '-22px' }}>
													<CardHeader>
														<Button
															color='info'
															isLink
															icon='ArrowBack'
															onClick={() =>
																setActiveTab(TABS.COMMENTS)
															}>
															Back
															{/*Back to List */}
														</Button>
													</CardHeader>
													<CardBody>
														<div className='row g-4'>
															{/* {data?.map((ele) => ( */}
															<div className='col-12 d-flex align-items-center'>
																<div className='flex-grow-1 ms-3 d-flex justify-content-between align-items-center'>
																	<figure className='mb-0'>
																		<div
																			style={{
																				display: 'flex',
																				alignItems:
																					'center',
																				gap: '3px',
																				marginTop: '-32px',
																				marginBottom:
																					'-10px',
																			}}>
																			{selectedEmployee.prof_img !==
																			undefined ? (
																				selectedEmployee.prof_img !==
																				null ? (
																					selectedEmployee.prof_img !==
																					'' ? (
																						<Avatar
																							style={{
																								marginBottom:
																									'-20px',
																							}}
																							//srcSet={User1Webp}
																							src={
																								selectedEmployee.prof_img
																							}
																							size={
																								55
																							}
																						/>
																					) : (
																						<Avatar
																							style={{
																								marginBottom:
																									'-20px',
																							}}
																							srcSet={
																								USERS
																									.GRACE
																									.src
																							}
																							size={
																								55
																							}
																						/>
																					)
																				) : (
																					// <Avatar srcSet={User1Webp} />
																					<Avatar
																						style={{
																							marginBottom:
																								'-20px',
																						}}
																						srcSet={
																							USERS
																								.GRACE
																								.src
																						}
																						size={55}
																					/>
																				)
																			) : (
																				<Avatar
																					style={{
																						marginBottom:
																							'-20px',
																					}}
																					srcSet={
																						USERS.GRACE
																							.src
																					}
																					size={55}
																				/>
																			)}
																			<blockquote className='blockquote'>
																				<p
																					style={{
																						// marginTop:
																						// 	'20px',
																						marginLeft:
																							'10px',
																						fontSize:
																							'18px',
																					}}>
																					{
																						selectedEmployee.name
																					}
																				</p>
																			</blockquote>
																		</div>

																		<div className='col-12'>
																			{/* <h4>Review</h4> */}
																			<div
																				style={{
																					display: 'flex',
																					alignItems:
																						'center',
																					marginLeft:
																						'65px',
																				}}>
																				<p
																					style={{
																						fontSize:
																							'22px',
																						// marginTop: '20px',
																						marginBottom:
																							'1px',
																						fontWeight:
																							'3px',
																					}}>
																					{parseFloat(
																						selectedEmployee.rating_score,
																					).toFixed(1)}
																					{/* {selectedEmployee.rating_score} */}
																				</p>
																				<div
																					style={{
																						marginBottom:
																							'3px',
																						marginLeft:
																							'8px',
																					}}>
																					{/* <RatingStar
																					colors={{
																						rear: '#3d4349',
																					}}
																					maxScore={100}
																					id='123'
																					rating={rating}
																					noBorder={true}
																					// onRatingChange={
																					// 	onRatingChange
																					// }
																				/> */}
																					<Ratings
																						rating={
																							rating
																						}
																						widgetDimensions='22px'
																						widgetRatedColors='rgb(255, 207, 82)'>
																						<Ratings.Widget widgetSpacing='2px' />
																						<Ratings.Widget widgetSpacing='2px' />
																						<Ratings.Widget widgetSpacing='2px' />
																						<Ratings.Widget widgetSpacing='2px' />
																						<Ratings.Widget widgetSpacing='2px' />
																					</Ratings>
																				</div>
																				{/* <p
																							style={{
																								fontSize:
																									'12px',
																								// marginTop: '22px',
																							}}>
																							20
																							Reviews
																						</p> */}
																			</div>
																		</div>
																		{/* </blockquote> */}
																		{/* <figcaption className='blockquote-footer mb-0'> */}
																		{/* {data.emp_note} */}
																		<div
																			style={{
																				marginLeft: '65px',
																			}}>
																			<figcaption
																				className='mb-0'
																				style={{
																					fontSize:
																						'15px',
																					color: 'gray',
																				}}>
																				{
																					selectedEmployee.emp_note
																				}
																			</figcaption>
																		</div>

																		{/* {USERS.GRACE.name} in{' '}
																<cite title='Company'>
																	Schedulerdesk
																</cite> */}
																		{/* </figcaption> */}
																	</figure>
																</div>
															</div>
														</div>
													</CardBody>
													{/*<CardBody>
													<div className='row g-4'>
														{/* {data?.map((ele) => ( *-/}
														<div className='col-12 d-flex align-items-center'>
															<div className='flex-grow-1 ms-3 d-flex justify-content-between align-items-center'>
																<figure className='mb-0'>
																	<div
																		style={{
																			display: 'flex',
																			alignItems: 'center',
																			gap: '3px',
																			marginTop: '-32px',
																			marginBottom: '-10px',
																		}}>
																		{selectedEmployee.prof_img !==
																		undefined ? (
																			selectedEmployee.prof_img !==
																			null ? (
																				selectedEmployee.prof_img !==
																				'' ? (
																					<Avatar
																						//srcSet={User1Webp}
																						src={
																							selectedEmployee.prof_img
																						}
																						size={55}
																					/>
																				) : (
																					<Avatar
																						srcSet={
																							USERS
																								.GRACE
																								.src
																						}
																						size={55}
																					/>
																				)
																			) : (
																				// <Avatar srcSet={User1Webp} />
																				<Avatar
																					srcSet={
																						USERS.GRACE
																							.src
																					}
																					size={55}
																				/>
																			)
																		) : (
																			<Avatar
																				srcSet={
																					USERS.GRACE.src
																				}
																				size={55}
																			/>
																		)}
																		<blockquote className='blockquote'>
																			<p
																				style={{
																					marginTop:
																						'20px',
																					marginLeft:
																						'10px',
																					fontSize:
																						'18px',
																				}}>
																				{
																					selectedEmployee.name
																				}
																			</p>
																			{/* <p>{data.name}</p> *-/}
																		</blockquote>
																	</div>

																	{/* <blockquote className='blockquote'> *-/}
																	<div className='col-12'>
																		{/* <h4>Review</h4> *-/}
																		<div
																			style={{
																				display: 'flex',
																				alignItems:
																					'center',
																				marginLeft: '65px',
																			}}>
																			<p
																				style={{
																					fontSize:
																						'16px',
																					// marginTop: '20px',
																					fontWeight:
																						'3px',
																				}}>
																				{parseFloat(
																					selectedEmployee.rating_score,
																				).toFixed(1)}
																			</p>
																			<div
																				style={{
																					marginBottom:
																						'20px',
																				}}>
																				<RatingStar
																				colors={{rear:'#3d4349',}}
																					maxScore={100}
																					id='123'
																					rating={rating}
																					noBorder={true}
																				/>
																			</div>
																			{/* <p
																							style={{
																								fontSize:
																									'12px',
																								// marginTop: '22px',
																							}}>
																							20
																							Reviews
																						</p> *-/}
																		</div>
																	</div>
																	{/* </blockquote> *-/}
																	{/* <figcaption className='blockquote-footer mb-0'> *-/}
																	{/* {data.emp_note} *-/}
																	<div
																		style={{
																			marginLeft: '65px',
																			fontSize: '14px',
																		}}>
																		<figcaption className='blockquote-footer mb-0'>
																			{
																				selectedEmployee.emp_note
																			}
																		</figcaption>
																	</div>

																	{/* {USERS.GRACE.name} in{' '}
																<cite title='Company'>
																	Schedulerdesk
																</cite> *-/}
																	{/* </figcaption> *-/}
																</figure>
															</div>
														</div>
													</div>
												</CardBody>*/}
												</Card>
												{selectedEmployee?.emp_gallery_img !== undefined ? (
													selectedEmployee?.emp_gallery_img !== null ? (
														selectedEmployee?.emp_gallery_img &&
														Array.isArray(
															selectedEmployee.emp_gallery_img,
														) &&
														selectedEmployee.emp_gallery_img.length >
															0 ? (
															<Card className='shadow-3d-primary'>
																<CardHeader>
																	<CardLabel
																		// icon='Summarize'
																		iconColor='success'>
																		<CardTitle
																			tag='h4'
																			className='h5'>
																			{t('Gallery')}
																		</CardTitle>
																	</CardLabel>
																</CardHeader>
																{/*}	<CardBody>
																<div
																	style={{
																		display: 'flex',
																		flexWrap: 'wrap',
																		alignItems: 'center',
																		marginTop: '-30px',
																	}}>
																	<PhotoProvider>
																		{selectedEmployee?.emp_gallery_img?.map(
																			(src, index) => (
																				<div
																					key={index}
																					style={{
																						margin: '10px',
																					}}>
																					<PhotoView
																						src={src}>
																						<img
																							src={
																								src
																							}
																							alt=''
																							style={{
																								width: '155px',
																								height: '155px',
																								objectFit:
																									'cover',
																								borderRadius:
																									'5px',
																							}}
																						/>
																					</PhotoView>
																				</div>
																			),
																		)}
																	</PhotoProvider>
																</div>
															</CardBody>*/}
																<CardBody>
																	<div
																		style={{
																			display: 'flex',
																			flexWrap: 'wrap',
																			alignItems: 'center',
																			marginTop: '-30px',
																		}}>
																		<PhotoProvider>
																			{selectedEmployee?.emp_gallery_img?.map(
																				(src, index) => (
																					<div
																						key={index}
																						style={{
																							margin: '10px',
																							cursor: 'pointer',
																						}}>
																						<PhotoView
																							src={
																								src
																							}>
																							<img
																								src={
																									src
																								}
																								alt=''
																								style={{
																									width: '125px',
																									height: '125px',
																									objectFit:
																										'cover',
																									borderRadius:
																										'5px',
																								}}
																							/>
																						</PhotoView>
																					</div>
																				),
																			)}
																		</PhotoProvider>
																	</div>
																</CardBody>
															</Card>
														) : (
															// <p style={{ marginTop:'15px',color:'black',display:'flex',fontSize:'18px',marginLeft:'40px' }}>Oops! The gallery is currently empty. Please check back soon for new updates.</p>
															<p />
														)
													) : (
														// <Avatar srcSet={User1Webp} />
														<p />
													)
												) : (
													<p />
												)}
											</div>
										</CardBody>
									</>
								)}
							</Card>
						</div>
					</div>
				</Page>
			</PageWrapper>
		</>
	);
};

export default ViewsServicePagewl;
